import { render, staticRenderFns } from "./BarChartHCA.vue?vue&type=template&id=493ead57"
import script from "./BarChartHCA.vue?vue&type=script&lang=js"
export * from "./BarChartHCA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports